import {GlobalContext} from "../../GlobalContext";
import {Button, Col, Form, Modal} from "react-bootstrap";
import React from "react";
import {OptionalSelect} from "./OptionalSelect";
import PickList from "./PickList";

export default class StringPickerModal extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            selectedValue: null,
            otherValue: null,
            otherKey: this.props.otherKey || 'Other'
        };
    }


    itemSelected = (e) => {
        this.setValue(e.target.value);
    }

    setValue = (val) => {
        this.setState({selectedValue: val});
        if (val != this.state.otherKey) {
            this.setState({otherValue: null});
        }
    }

    ok = () => {
        let val = this.state.selectedValue;
        if (this.props.allowOther && this.state.selectedValue === this.state.otherKey && this.state.otherValue) {
            val = this.state.otherValue;
        }
        this.props.onOk(val);
    }

    render() {
        return <Modal size={this.props.size || "md"} show={this.props.show} onHide={this.props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>{this.props.title || 'Select a Value'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Row>
                        <Col>
                            {
                                this.props.picklistName ? <PickList dropdown listName={this.props.picklistName} options={this.props.options}
                                                                    value={this.state.selectedValue}
                                                                    onItemSelected={this.setValue}
                                                                    required={!this.props.canSelectNone}/>
                                :
                                <OptionalSelect options={this.props.options}
                                                labelKey={this.props.labelKey} valueKey={this.props.valueKey}
                                                canSelectNone={this.props.canSelectNone}
                                                noneValue={this.props.noneValue}
                                                noneLabel={this.props.noneLabel}
                                                value={this.state.selectedValue} onChange={this.itemSelected}/>
                            }
                        </Col>
                    </Form.Row>
                    {
                        this.props.allowOther && this.state.selectedValue === this.state.otherKey &&
                            <Form.Row className={"mt-2"}>
                                <Col>
                                    <Form.Control placeholder={'Other value'} value={this.state.otherValue} onChange={e => this.setState({otherValue: e.target.value})}/>
                                </Col>
                            </Form.Row>
                    }
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onCancel}>
                    Cancel
                </Button>
                <Button variant="dark" onClick={this.ok} disabled={!this.props.canSelectNone && this.state.selectedValue == null}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    }
}